<template>
    <div id="connectionContainer">
        <div v-show="!this.$store.state.loading && !this.$store.state.successful">
            <div class="connectionHeader">
                <div class="connectionInfo">
                    <p class="connectionInfoLine">
                        <span class="connectionInfoItem">商品名 : </span>
                        <span class="connectionInfoValue">{{ this.productInfo.productName }}</span>
                    </p>
                    <p class="connectionInfoLine">
                        <span class="connectionInfoItem">商品番号 : </span>
                        <span class="connectionInfoValue">{{ this.productInfo.productId }}</span>
                    </p>
                </div>
                <a class="btn closeBtn" @click="$emit('modalClosed')">×</a>
            </div>
            <div class="connectionSetting">
                <div class="connectionSettingHeader">
                    <div class="connectionSettingHeaderItem">
                        <input id="isLinkedThisProduct" type="checkbox" @change="isLinkedThisProductDisp"
                            v-model="isChecked">
                        <label class="isLinkedThisProductCheckBox"
                            for="isLinkedThisProduct">全商品の内いずれかと紐付き済み広告を非表示</label>
                    </div>
                </div>
                <div class="connectionListContainer">
                    <!-- 紐付け済み 商品-広告 -->
                    <div class="connectionListInner">
                        <!-- 紐付け済み 商品-広告 1つ以上の場合 true -->
                        <ul v-if="this.productInfo.linkedAds != undefined">
                            <!-- 広告媒体ごとに広告を出力 広告媒体(Facebook, Yahoo(検索広告･ディスプレイ広告), Google, Line, Criteo) -->
                            <li v-for="(adMedia, i) in Object.keys(this.productInfo.unlinkedAds)" :key="i">
                                <div v-if="productInfo.linkedAds[adMedia] != undefined">
                                    <!-- 広告媒体名を表示 -->
                                    <div class="mediaLine">{{ adMedia }}</div>
                                    <!-- 広告媒体名ごとに広告セットを表示 -->
                                    <div v-for="(linkedAdset, adsetId, i) in productInfo.linkedAds[adMedia]" :key="i"
                                        :class="{ 'isSelected': selected == 'linked' + adsetId }" class="selectAd"
                                        @click="onClick(adMedia, adsetId, productInfo.linkedAds[adMedia][adsetId][Object.keys(linkedAdset)[0]])">
                                        <!-- 広告セット名を表示 -->
                                        <span :class="{ 'adsetName': adMedia === 'google' }">{{
            Object.values(linkedAdset[Object.keys(linkedAdset)[0]])[0]['adGroupName']
        }}</span>
                                        <span v-if="adMedia === 'google'" class="right">
                                            {{
            Object.values(linkedAdset[Object.keys(linkedAdset)[0]])[0]['adCampaignName']
        }}
                                        </span>
                                        <!-- 広告を表示 -->
                                        <ul>
                                            <li v-for="(linkedAd, key, j) in linkedAdset[Object.keys(linkedAdset)[1]]"
                                                :key="j">
                                                <span v-if="linkedAd['isLinkedThisItem']">○</span>
                                                <span v-else>× </span>
                                                <!-- 既に登録している広告名の場合true、新たに追加した広告名の場合falseの形式で表示 -->
                                                <span>{{ linkedAd['adName']['adName'] == null ?
            linkedAd['adName'] + "" : linkedAd['adName']['adName'] }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="controlConnection">
                        <div class="connectionControlBtn">
                            <div>追加</div>
                            <div id="addBtn" class="controlBtn"
                                :class="{ 'isSelected': selected == 'unlinked' + selectedIndex, 'notSelected': selected == 'linked' + selectedIndex }"
                                @click="addAds(activeAdMedia, activeAdMediakey)">←</div>
                        </div>
                        <div class="connectionControlBtn">
                            <div>削除</div>
                            <div id="deleteBtn" class="controlBtn"
                                :class="{ 'isSelected': selected == 'linked' + selectedIndex, 'notSelected': selected == 'unlinked' + selectedIndex }"
                                @click="deleteAds(activeAdMedia)">→</div>
                        </div>
                    </div>
                    <!-- 未紐付け 商品-広告 -->
                    <div class="connectionListInner">
                        <ul>
                            <!-- 広告媒体ごとに広告を出力 広告媒体(Facebook, Yahoo(検索広告･ディスプレイ広告), Google, Line, Criteo) -->
                            <li v-for="(adMedia, i) in Object.keys(this.productInfo.unlinkedAds) " :key="i">
                                <!-- 広告媒体名を表示 -->
                                <div class="mediaLine">{{ adMedia }}</div>
                                <!-- 広告媒体名ごとに広告セットを表示 -->
                                <div v-for="(unlinkedAdset, adsetId, j) in productInfo.unlinkedAds[adMedia]" :key="j"
                                    :class="{ 'isSelected': selected == 'unlinked' + adsetId }" class="selectAd">

                                    <!-- 広告セット名を表示 -->
                                    <!-- Object.keys(unlinkedAdset)[0] : adset or adGroup -->
                                    <!-- unlinkedAdset[Object.keys(unlinkedAdset)[0]] : { "23846922705050589": "整体ネックポール（P）" } -->
                                    <!-- Object.values(unlinkedAdset[Object.keys(unlinkedAdset)[0]])[0] : 整体ネックポール（P） -->
                                    <!-- <span>{{Object.values(unlinkedAdset[Object.keys(unlinkedAdset)[0]])[0]}}</span> -->
                                    <div v-show="dispUnlinkedAdset(unlinkedAdset[Object.keys(unlinkedAdset)[1]])[1] != 0"
                                        @click="onDeployment(adMedia, [Object.keys(unlinkedAdset)[0], Object.keys(unlinkedAdset)[1]], adsetId, productInfo.unlinkedAds[adMedia][adsetId][Object.keys(unlinkedAdset)[0]], productInfo.unlinkedAds[adMedia][adsetId][Object.keys(unlinkedAdset)[1]])">
                                        <span :class="{ 'adsetName': adMedia === 'google' }">
                                            {{
            Object.values(unlinkedAdset[Object.keys(unlinkedAdset)[0]])[0]['adGroupName']
        }}
                                        </span>
                                        <span v-if="adMedia === 'google'" class="right">
                                            {{
            Object.values(unlinkedAdset[Object.keys(unlinkedAdset)[0]])[0]['adCampaignName']
        }}
                                        </span>
                                    </div>

                                    <!-- 広告を表示 -->
                                    <ul v-show="adsetId == deploymented">
                                        <!-- {{ Object.values(unlinkedAdset[ Object.keys(unlinkedAdset)[1] ])[0]["isLinkedAllProducts"] }} -->
                                        <li v-for="(unlinkedAd, adId, k) in dispUnlinkedAdset(unlinkedAdset[Object.keys(unlinkedAdset)[1]])[0]"
                                            :key="k">
                                            <input type="checkbox" :id=adId v-model="defaultCheckBox[adId]"
                                                @click="onChangeCheck($event, adId)" />
                                            <label :for=adId>{{ typeof unlinkedAd == "object" ?
                                                unlinkedAd['adName'] : unlinkedAd }}</label>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="connectionSettingFooter">
                    <a class="btn connectionSubmitBtn" @click="updateSettingAds">更新</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LinkProductAndAds',
    data() {
        return {
            productInfo: "",
            selected: null,
            isChecked: false,
            deploymented: null,
            activeAdMedia: null,
            activeAdMediakey: null,
            activeAdset: "",
            activeAds: "",
            activeAdsIds: [],
            allActiveAdsIds: { facebook: "", yahooSearch: "", yahooDisplay: "", google: "", googleShopping: "", googlePmax: "", line: "", criteo: "" },
            selectedIndex: null,
            defaultCheckBox: {}  // チェックボックスのデフォルト値を格納
        }
    },
    props: {
        clickProductNo: Number
    },
    mounted: function () {
        this.$store.dispatch("loading", true);
        this.axios.get("/api/productAndAds?productId=" + this.clickProductNo + "")
            .then((res) => {
                this.productInfo = res.data
                this.deploymented = null
                this.$store.dispatch("loading", false);
            }).catch(() => {
            })
    },
    methods: {
        // 紐付け済み広告表示チェックボックス押下時
        isLinkedThisProductDisp() {
            if (this.isChecked) {
                // チェックする場合
                this.isChecked = true
            } else {
                // チェックしない場合
                this.isChecked = false
            }
        },
        // 広告セットを展開 引数(広告媒体の名前, 広告媒体のキーの名前, 広告セットID, 広告セットオブジェクト, 広告オブジェクト)
        onDeployment(adMedia, adMediaKey, adsetId, adset, ads) {
            // 広告セット押下時(展開)
            this.defaultCheckBox = {};
            this.selected = 'unlinked' + adsetId
            this.selectedIndex = adsetId
            if (this.deploymented != adsetId) {
                // 非展開時(展開する)
                this.activeAdMedia = adMedia
                this.activeAdMediakey = adMediaKey
                this.deploymented = adsetId
                this.activeAdset = adset
                this.activeAds = Object.assign({}, ads)
                for (let i = 0; i < Object.keys(this.activeAds).length; i++) {
                    this.activeAds[Object.keys(this.activeAds)[i]] = ""
                    if (adMedia === 'googleShopping' || adMedia === 'googlePmax') {
                        this.$set(this.defaultCheckBox, Object.keys(this.activeAds)[i], false);
                        this.activeAds[Object.keys(this.activeAds)[i]] = { "adName": Object.values(ads)[i], "isLinkedThisItem": false }
                    } else {
                        this.$set(this.defaultCheckBox, Object.keys(this.activeAds)[i], true);
                        this.activeAds[Object.keys(this.activeAds)[i]] = { "adName": Object.values(ads)[i], "isLinkedThisItem": true }
                    }
                }
            }
        },
        onChangeCheck(e, ad) {
            // 広告のチェックボックス押下時
            if (e.target.checked) {
                // チェックする場合
                this.activeAds[ad].isLinkedThisItem = true
            } else {
                // チェックしない場合
                this.activeAds[ad].isLinkedThisItem = false
            }
            e.stopPropagation()
        },
        addAds(selectedAdMedia, selectedAdMediakey) {
            // 広告セット(広告)追加押下時
            if (this.productInfo.linkedAds == undefined) {
                // 広告セット(広告)が設定されていない場合
                this.productInfo = Object.assign({}, this.productInfo, { linkedAds: { [selectedAdMedia]: { [Object.keys(this.activeAdset)]: { [selectedAdMediakey[0]]: this.activeAdset, [selectedAdMediakey[1]]: this.activeAds } } } })
            } else {
                // 広告セット(広告)が設定されている場合
                if (this.productInfo.linkedAds[selectedAdMedia] == undefined) {
                    this.productInfo.linkedAds = Object.assign({}, this.productInfo.linkedAds, { [selectedAdMedia]: { [Object.keys(this.activeAdset)]: { [selectedAdMediakey[0]]: this.activeAdset, [selectedAdMediakey[1]]: this.activeAds } } })
                } else {
                    // 既に設定されている広告媒体の広告セット(広告)が設定された場合
                    this.$set(this.productInfo.linkedAds[selectedAdMedia], [Object.keys(this.activeAdset)], { [selectedAdMediakey[0]]: this.activeAdset, [selectedAdMediakey[1]]: this.activeAds })
                }
            }
            this.selected = null
            this.deploymented = null
        },
        onClick(adMedia, adsetId, adset) {
            // 設定済み広告セット押下時
            this.selected = 'linked' + adsetId
            this.selectedIndex = adsetId
            this.activeAdMedia = adMedia
            this.activeAdset = adset
            this.deploymented = null
        },
        deleteAds(selectedAdMedia) {
            // 広告セット(広告)削除押下時
            if (Object.values(this.productInfo.linkedAds[selectedAdMedia]).length == 1) {
                // 広告セット(広告)が1つしか設定していない場合
                delete this.productInfo.linkedAds[selectedAdMedia]
            } else {
                // 広告セット(広告)が複数設定している場合
                delete this.productInfo.linkedAds[selectedAdMedia][Object.keys(this.activeAdset)]
                this.productInfo.linkedAds = Object.assign({}, this.productInfo.linkedAds)
            }
            this.selected = null
        },
        updateSettingAds() {
            // 更新ボタン押下時
            // 広告媒体ごとにループ
            Object.keys(this.productInfo.unlinkedAds).forEach(adMedia => {
                if (this.productInfo.linkedAds[adMedia] != undefined) {
                    // 広告媒体に属する広告セット(広告)が紐付け対象に設定されていた場合
                    for (let j = 0; j < Object.keys(this.productInfo.linkedAds[adMedia]).length; j++) {
                        // 広告セットID分ループ
                        // Object.keys(this.productInfo.linkedAds[adMedia])[j] : 広告セットID
                        // Object.keys(this.productInfo.linkedAds[adMedia][Object.keys(this.productInfo.linkedAds[adMedia])[j]])[1] : ads
                        for (let k = 0; k < Object.keys(this.productInfo.linkedAds[adMedia][Object.keys(this.productInfo.linkedAds[adMedia])[j]][Object.keys(this.productInfo.linkedAds[adMedia][Object.keys(this.productInfo.linkedAds[adMedia])[j]])[1]]).length; k++) {
                            // 広告ID分ループ
                            if (Object.values(this.productInfo.linkedAds[adMedia][Object.keys(this.productInfo.linkedAds[adMedia])[j]][Object.keys(this.productInfo.linkedAds[adMedia][Object.keys(this.productInfo.linkedAds[adMedia])[j]])[1]])[k]["isLinkedThisItem"]) {
                                this.activeAdsIds.push(Object.keys(this.productInfo.linkedAds[adMedia][Object.keys(this.productInfo.linkedAds[adMedia])[j]][Object.keys(this.productInfo.linkedAds[adMedia][Object.keys(this.productInfo.linkedAds[adMedia])[j]])[1]])[k])
                            }
                        }
                    }
                    // 全広告媒体の広告セット(広告)を格納した連想配列に各広告媒体の広告セット(広告)を格納
                    this.allActiveAdsIds[adMedia] = Object.assign({}, this.activeAdsIds)
                    this.activeAdsIds.length = 0
                }
            });

            this.$store.dispatch("loading", true)
            this.axios.put("api/productAndAds", {
                productId: this.productInfo.productId,
                adIds: {
                    facebook: this.allActiveAdsIds["facebook"] == undefined ? undefined : this.allActiveAdsIds["facebook"],
                    yahooSearch: this.allActiveAdsIds["yahooSearch"] == undefined ? undefined : this.allActiveAdsIds["yahooSearch"],
                    yahooDisplay: this.allActiveAdsIds["yahooDisplay"] == undefined ? undefined : this.allActiveAdsIds["yahooDisplay"],
                    google: this.allActiveAdsIds["google"] == undefined ? undefined : this.allActiveAdsIds["google"],
                    googleShopping: this.allActiveAdsIds["googleShopping"] == undefined ? undefined : this.allActiveAdsIds["googleShopping"],
                    googlePmax: this.allActiveAdsIds["googlePmax"] == undefined ? undefined : this.allActiveAdsIds["googlePmax"],
                    line: this.allActiveAdsIds["line"] == undefined ? undefined : this.allActiveAdsIds["line"],
                    criteo: this.allActiveAdsIds["criteo"] == undefined ? undefined : this.allActiveAdsIds["criteo"],
                    microsoft: this.allActiveAdsIds["microsoft"] == undefined ? undefined : this.allActiveAdsIds["microsoft"],
                    googleDemandGen: this.allActiveAdsIds["googleDemandGen"] == undefined ? undefined : this.allActiveAdsIds["googleDemandGen"],
                }
            }).then(() => {
                this.axios.get("/api/linkedProductAndAds?page=1")
                    .then((res) => {
                        this.responseData = res.data
                        this.$emit("updateProducts", this.responseData)
                        this.modalShow = false
                        this.$modal.hide("LinkProductAndAds")
                    }).catch(() => {
                    })
            }).catch(() => {
            })
        },
        dispUnlinkedAdset(unlinkedAdset) {
            // 全商品の内いずれかと紐付き済み広告を非表示チェックボックス押下時
            const fileterUnlinkedAdset = Object.values(unlinkedAdset).filter(unlinkedAd => {
                return unlinkedAd["isLinkedAllItems"] == false
            })
            if (this.isChecked) {
                // チェックする場合
                return [fileterUnlinkedAdset, Object.values(fileterUnlinkedAdset).length]
            } else {
                // チェックしない場合
                return [unlinkedAdset, Object.values(unlinkedAdset).length]
            }
        }
    }
}
</script>

<style scoped lang="sass">
#connectionContainer
    height: 100%
    margin: 15px 15px 0 20px
    .connectionHeader
        display: flex
        font-size: 1.5rem
        height: 20%
        padding: 5px
        text-align: center
        .connectionInfo
            color: $grayColor
            flex: 1 1 100%
            .connectionInfoLine
                color: $grayColor
                font-size: 1.5rem
                margin-bottom: 25px
                text-align: left
                span
                    display: inline-block
                .connectionInfoItem
                    min-width: 100px
                .connectionInfoValue
                    font-weight: 700
        .closeBtn
            border: 1px solid $whiteColor
            display: block
            flex: 1 0 auto
            font-size: 1.7rem
            height: 40px
            margin-left: 5px
            padding: 10px 10px
            width: 40px
            &:hover
                border: 1px solid $mainColor
    .connectionSetting
        color: $grayColor
        display: flex
        flex-direction: column
        font-size: 1.5rem
        height: 70%
        padding: 5px
        .connectionSettingHeader
            flex: 0 1 0%
            margin-bottom: 10px
            .connectionSettingHeaderItem
                float: right
                padding: 10px 0
                #isLinkedThisProduct
                    display: none
                .isLinkedThisProductCheckBox
                    line-height: 18px
                    padding-left: 25px
                    position: relative
                    &::before
                        background: $whiteColor
                        border: 1px solid $grayColor
                        content: ''
                        cursor: pointer
                        display: block
                        height: 15px
                        position: absolute
                        width: 15px
                    &::after
                        border-bottom: 3px solid $mainColor
                        border-right: 3px solid $mainColor
                        content: ''
                        cursor: pointer
                        display: block
                        height: 9px
                        left: 5px
                        margin-top: -8px
                        opacity: 0
                        position: absolute
                        top: 50%
                        transform: rotate(45deg)
                        width: 5px
                #isLinkedThisProduct:checked + .isLinkedThisProductCheckBox::after
                    opacity: 1
        .connectionListContainer
            display: flex
            flex: 1 1 0%
            .connectionListInner
                border: 1px solid $grayColor
                flex: 1 1 45%
                font-size: 1.3rem
                max-height: 560px
                overflow-Y: scroll
                .mediaLine
                    background: $mainColor
                    color: $whiteColor
                    padding: 5px
                .selectAd
                    cursor: pointer
                    list-style: none
                    margin: 4px 10px
                    transition: 0.2s ease-out
                    overflow: hidden
                    &:hover
                        background: $mainColor
                        color: $whiteColor
                    .adsetName
                        display: inline-block
                        white-space: nowrap
                        overflow: hidden
                        width: calc(100% - 250px)
                    .right
                        float: right
                        display: inline-block
                        width: 250px
                        white-space: nowrap
                    li
                        display: flex
                        flex-direction: row
                        margin: 5px 0
                        span
                            padding: 5px 2px
                .isSelected
                    background: $mainColor
                    color: $whiteColor
            .controlConnection
                align-self: center
                flex: 1 1 10%
                .connectionControlBtn
                    font-weight: 700
                    text-align: center
                    .controlBtn
                        background: #ccc
                        border: 1px solid $grayColor
                        border-radius: 4px
                        color: $whiteColor
                        height: 35px
                        line-height: 35px
                        pointer-events: none
                        transition: 0.2s ease-out
                        margin: 5px auto 30px
                        width: 35px
                        &:hover
                            background: $mainColor
                            color: $whiteColor
                    .isSelected
                        background: $whiteColor
                        color: $mainColor
                        cursor: pointer
                        pointer-events: auto
                    .notSelected
                        background: #ccc
                        color: $whiteColor
        .connectionSettingFooter
            display: flex
            flex: 0 1 0%
            justify-content: center
            margin-top: 50px
            .connectionSubmitBtn
                border: 1px solid $mainColor
                padding: 15px 5px
                width: 100px
                &:hover
                    border: 1px solid $mainColor
</style>
